import { FC, useState } from 'react'
import { useNavigate } from 'react-router'
import { Table, Toolbar, BreadcrumHeader } from 'shared'
import { useTableHandlers } from 'hooks/useTableHandlers'
import TaskStatusCountCell from 'shared/molecules/table/cells/TaskStatusCountCell'
import { BreadcrumbItemType } from 'shared/molecules/Breadcrum/Breadcrum'
import { Client, ClientListRequest } from '../types'
import RuleConfigration from '../clientRule/CreateClientRuleConfig'
import { useGetClientQuery } from '../clientApiSlice'
import CreateClient from '../createEditClient/CreateClient'
import '../client.scss'

const { Column, HeaderCell, Cell, ActionCell, DateTimeCell } = Table

const ClientList: FC = () => {
  const navigate = useNavigate()
  const [selectedClient, setSelectedClient] = useState<Client | null>(null)
  const [addClientModal, setAddClientModal] = useState(false)
  const [openRuleModal, setOpenRuleModal] = useState<boolean>(false)
  const [isEditMode, setIsEditMode] = useState<boolean>(false)
  const { requestBody, onPageChange } = useTableHandlers<
    Client,
    ClientListRequest
  >(
    {
      page: { size: 10, number: 0 }
    },
    'name'
  )
  const { data: ClientData, isLoading } = useGetClientQuery(requestBody)

  const handleTabChange = () => { }

  const handleAction = (eventKey: string | undefined, rowData: Client) => {
    switch (eventKey) {
      case '2': {
        setSelectedClient(rowData)
        setIsEditMode(true)
        setAddClientModal(true)
        break
      }
      case '10': {
        setSelectedClient(rowData)
        setOpenRuleModal(true)
        break
      }
      default:
        break
    }
  }
  const COLUMNS = [
    { key: 'name', label: 'Name' },
    { key: 'clientId', label: 'ClientId' },
    { key: 'userName', label: 'UserName' }
  ]

  const options = [
    {
      label: 'All',
      value: 'All',
      onClick: () => handleTabChange()
    }
  ]

  const handleClose = () => {
    setOpenRuleModal(false)
    setAddClientModal(false)
    setIsEditMode(false)
    setSelectedClient(null)
  }
  const total = ClientData?.totalElements ?? 0

  const breadcrumbItems: BreadcrumbItemType[] = [
    {
      label: 'Client',
      path: '/client',
      isActive: true
    }
  ]

  return (
    <div className="list">
      <BreadcrumHeader items={breadcrumbItems} />
      <Toolbar options={options} total={total} onButtonClick={() => { setSelectedClient(null); setIsEditMode(false); setAddClientModal(true) }}
        buttonName="Add Client" />
      <div className="list__main-container">
        <Table
          data={ClientData?.content ?? []}
          loading={isLoading}
          paginated
          pageSizeOptions={[10, 20, 30]}
          total={total}
          defaultPageSize={10}
          onPageChange={onPageChange}
          onRowClick={(rowData: Client) => {
            const id = (rowData as any)?.id
            if (id) {
              navigate(`/client/email/${id}`)
            }
          }}
        >
          {COLUMNS.map((column, index) => {
            const { key, label } = column
            return (
              <Column
                flexGrow={1}
                key={key}
                align={index === 0 ? 'left' : 'center'}
                sortable
              >
                <HeaderCell>{label}</HeaderCell>
                <Cell dataKey={key} tooltip />
              </Column>
            )
          })}
          <Column flexGrow={1} align="center">
            <HeaderCell>Pending File</HeaderCell>
            <TaskStatusCountCell dataKey="totalPendingFile" />
          </Column>
          <Column flexGrow={1} align="center">
            <HeaderCell>Completed File</HeaderCell>
            <TaskStatusCountCell dataKey="totalCompletedFile" />
          </Column>
          <Column flexGrow={1} align="center">
            <HeaderCell>Untrained File</HeaderCell>
            <TaskStatusCountCell dataKey="totalUntrainedFile" />
          </Column>
          <Column flexGrow={1} align="center">
            <HeaderCell>Failed File</HeaderCell>
            <TaskStatusCountCell dataKey="totalFailedFile" />
          </Column>
          <Column flexGrow={1} align="center">
            <HeaderCell>CreatedOn</HeaderCell>
            <DateTimeCell dataKey="createdOn" format="dd/MMM/yy, h:mm a" />
          </Column>

          <Column align="center" key="action" sortable>
            <HeaderCell>Action</HeaderCell>

            <ActionCell
              style={{ paddingLeft: '22%' }}
              tooltip
              dataKey="action"
              onAction={handleAction}

              actionOptions={['Rule Configration', 'Edit']}
            />
          </Column>
        </Table>
      </div>

      <RuleConfigration
        open={openRuleModal}
        onClose={handleClose}
        client={selectedClient}
      />
      <CreateClient
        open={addClientModal}
        onClose={handleClose}
        isEditMode={isEditMode}
        client={selectedClient as any}
      />
    </div>
  )
}
export default ClientList
